<template>
    <div class="user-config-box">
        <div>
            <el-button type="danger" @click="openAddDialog">增加用户限额配置</el-button>
            <el-button type="primary" @click="refreshUserWithdrawalConfig">刷新列表数据</el-button>
            <span>   说明：1、不用的用户配置尽量删掉；2、用户不限额把额度设置大一点</span>
        </div>

        <el-table class="conf-table" :data="userList">
            <el-table-column prop="userId" label="用户id" width="300"></el-table-column>
            <el-table-column label="当日限额参数值" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.amount}}
                </template>
            </el-table-column>
            <el-table-column label="单次限额参数值" show-overflow-tooltip>
                <template slot-scope="scope">
                    {{scope.row.singleAmount}}
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <el-button type="danger" @click="updateDialog(scope.row)">修改</el-button>
                    <el-button type="danger" @click="deleteUserConfig(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!--币种增加/修改弹框-->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="60%" @close="clearData"
                   :close-on-click-modal="false">
            <el-form label-width="300px">
                <el-form-item label="用户ID：" style="padding-top: 20px">
                    <el-input v-model="userData.userId" placeholder="用户ID" style="width: 500px"
                              @input="checkUser"></el-input>
                </el-form-item>
                <el-form-item label="用户当日限额币种：" style="padding-top: 20px">
                    <div style="margin-top: 50px">
                        <div class="address-model" v-for="item in coinList" :key="item.id">
                            <span style="padding-right: 20px">币种</span>
                            <el-input style="width: 200px;margin-top: 5px;margin-bottom: 5px" placeholder="请输入币种"
                                      v-model="item.coin"></el-input>
                            <span style="padding-right: 10px;padding-left: 10px">额度</span>
                            <el-input style="width: 200px;margin-top: 5px;margin-bottom: 5px" placeholder="请输入额度"
                                      v-model.number="item.value" type="number"></el-input>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       @click="deleteCoinFrom(item.id)"></el-button>
                        </div>
                    </div>

                    <el-button style="margin-top: 10px" icon="el-icon-plus" type="primary"
                               @click="addCoinFrom"></el-button>
                </el-form-item>

                <el-form-item label="用户单次限额币种：" style="padding-top: 20px">
                    <div style="margin-top: 50px">
                        <div class="address-model" v-for="item in singleCoinList" :key="item.id">
                            <span style="padding-right: 20px">币种</span>
                            <el-input style="width: 200px;margin-top: 5px;margin-bottom: 5px" placeholder="请输入币种"
                                      v-model="item.coin"></el-input>
                            <span style="padding-right: 10px;padding-left: 10px">额度</span>
                            <el-input style="width: 200px;margin-top: 5px;margin-bottom: 5px" placeholder="请输入额度"
                                      v-model.number="item.value" type="number"></el-input>
                            <el-button style="margin-left: 30px" icon="el-icon-minus" type="danger"
                                       @click="deleteSingleCoinFrom(item.id)"></el-button>
                        </div>
                    </div>

                    <el-button style="margin-top: 10px" icon="el-icon-plus" type="primary"
                               @click="addSingleCoinFrom"></el-button>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button type="danger" :loading="loading" @click="updateOrAddUserConfig">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import api from './api';

    export default {
        name: "UserWithdrawalConfig",

        data() {
            return {
                userList: [],
                dialogTitle: '新增',
                dialogVisible: false,
                userData: {userId: "", amount: {}, singleAmount: {}},
                coinList: [{id: 1, coin: '', value: 0}],
                loading: false,
                singleCoinList: [{id: 1, coin: '', value: 0}],
            }
        },
        created() {
            this.getUserWithdrawalConfig();
        },
        methods: {
            checkUser() {
                for (let i = 0; i < this.userList.length; i++) {
                    if (this.userList[i].userId == this.userData.userId.trim()) {
                        this.coinList = [];
                        this.singleCoinList = [];
                        let j = 1;
                        for (let key in this.userList[i].amount) {
                            let amount = {id: j++, coin: key, value: this.userList[i].amount[key]};
                            this.coinList.push(amount);
                        }
                        j = 1;
                        for (let key in this.userList[i].singleAmount) {
                            let amount = {id: j++, coin: key, value: this.userList[i].singleAmount[key]};
                            this.singleCoinList.push(amount);
                        }
                        break;
                    }else{
                        this.coinList = [];
                        this.singleCoinList = [];
                    }
                }
            },
            updateOrAddUserConfig() {
                if (this.userData.userId.trim() == "") {
                    this.$message.error('请输入用户id！');
                    return
                }
                this.userData.amount = {};
                this.userData.singleAmount = {};
                for (let i = 0; i < this.coinList.length; i++) {
                    if (this.coinList[i].coin.trim() != "") {
                        this.userData.amount[this.coinList[i].coin.trim()] = this.coinList[i].value;
                    }
                }
                for (let i = 0; i < this.singleCoinList.length; i++) {
                    if (this.singleCoinList[i].coin.trim() != "") {
                        this.userData.singleAmount[this.singleCoinList[i].coin.trim()] = this.singleCoinList[i].value;
                    }
                }
                let tag = true;
                for (let key in this.userData.amount) {
                    if (key.trim() == "") {
                        this.$message.error('请完善表单！');
                        tag = false;
                        return
                    }
                }
                for (let key in this.userData.singleAmount) {
                    if (key.trim() == "") {
                        this.$message.error('请完善表单！');
                        tag = false;
                        return
                    }
                }
                if (!tag) {
                    this.$message.error('请完善表单！');
                    return
                }
                this.updateUserWithdrawalConfig();
            },
            openAddDialog() {
                this.dialogTitle = "新增";
                this.dialogVisible = true;
            },
            updateDialog(row) {
                this.dialogTitle = "修改";
                this.userData.userId = row.userId;
                this.userData.amount = {};
                this.userData.singleAmount = {};
                this.coinList = [];
                this.singleCoinList = [];
                let i = 1;
                for (let key in row.amount) {
                    let amount = {id: i++, coin: key, value: row.amount[key]};
                    this.coinList.push(amount);
                }
                i = 1;
                for (let key in row.singleAmount) {
                    let amount = {id: i++, coin: key, value: row.singleAmount[key]};
                    this.singleCoinList.push(amount);
                }
                this.dialogVisible = true;
            },
            addCoinFrom() {
                this.coinList.push({
                    id: this.coinList.length + 1,
                    coin: "",
                    value: 0
                });
            },
            deleteCoinFrom(id) {
                for (let i = 0; i < this.coinList.length; i++) {
                    if (this.coinList[i].id == id) {
                        this.coinList.splice(i, 1);
                        return;
                    }
                }
            },
            addSingleCoinFrom() {
                this.singleCoinList.push({
                    id: this.singleCoinList.length + 1,
                    coin: "",
                    value: 0
                });
            },
            deleteSingleCoinFrom(id) {
                for (let i = 0; i < this.singleCoinList.length; i++) {
                    if (this.singleCoinList[i].id == id) {
                        this.singleCoinList.splice(i, 1);
                        return;
                    }
                }
            },
            deleteUserConfig(row) {
                this.$confirm('确认要删除该用户配置吗？', '提示', {type: 'warning'}).then(() => {
                    for (let i = 0; i < this.userList.length; i++) {
                        if (this.userList[i].userId == row.userId) {
                            this.userList.splice(i, 1);
                            api.updateConf({
                                key: 'WITHDRAW_LIMIT_AMOUNT',
                                value: JSON.stringify(this.userList)
                            }).then(() => {
                                this.getUserWithdrawalConfig();
                                this.$message.success('删除成功！');
                            });
                            return
                        }
                    }
                });
            },
            getUserWithdrawalConfig() {
                api.getConfList({key: 'WITHDRAW_LIMIT_AMOUNT'}).then(({data}) => {
                    this.userList = JSON.parse(data[0].confValue);
                }).catch(() => {
                    // this.$message.error('数据解析失败！');
                });
            },
            refreshUserWithdrawalConfig() {
                api.refreshConfigByKey({key: 'WITHDRAW_LIMIT_AMOUNT'}).then(({data}) => {
                    this.userList = JSON.parse(data.confValue);
                    this.$message.success('刷新成功');
                });
            },
            updateUserWithdrawalConfig() {
                this.$confirm('确认要进行此操作吗？', '提示', {type: 'warning'}).then(() => {
                        let tag = true;
                        for (let i = 0; i < this.userList.length; i++) {
                            if (this.userList[i].userId == this.userData.userId.trim()) {
                                this.userList[i] = this.userData;
                                tag = false;
                                break
                            }
                        }
                        if (tag) {
                            //新增
                            this.userList.push(this.userData);
                        }
                        api.updateConf({
                            key: 'WITHDRAW_LIMIT_AMOUNT',
                            value: JSON.stringify(this.userList)
                        }).then(() => {
                            this.dialogVisible = false;
                            this.getUserWithdrawalConfig();
                            this.$message.success('操作成功！');
                        });
                    }
                );
            },
            clearData() {
                this.dialogTitle = '';
                this.userData = {userId: "", amount: {}, singleAmount: {}};
                this.coinList = [{id: 1, coin: '', value: 0}];
                this.singleCoinList = [{id: 1, coin: '', value: 0}];
                this.loading = false;
            }
        }
    }
</script>

<style lang="less" scoped>
    .user-config-box {
        .conf-table {
            margin-top: 20px;
        }
    }
</style>
